import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=5e21481c&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./Index.vue?vue&type=style&index=0&id=5e21481c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e21481c",
  null
  
)

export default component.exports